import { useQuery } from "@tanstack/react-query";
import { getAllJobTitles } from "../../api/apiJobTitles";
import i18next from "i18next";

export function useGetJobTitles(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["jobTitles", page, perPage, filters, i18next.language],
        queryFn: () => getAllJobTitles(page, perPage, filters),
        retry: false,
    });

    const jobTitles = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, jobTitles, meta };
}
